<ng-container *transloco="let t">

  <raf-loading *ngIf="productLoading$ | async"></raf-loading>

  <ng-container *ngIf="(fullPageError$ | async) === null">
    <ng-container *ngIf="product$ | async as product">
      <raf-section>
        <div class="two-side-layout break-lg two-side-layout--product-detail">
          <div class="secondary-side secondary-side--gallery-side">
            <raf-gallery [images]="product.images || []" [labels]="product.labels"
                         [alternativeText]="product.name"></raf-gallery>
          </div>

          <div class="primary-side">
            <raf-text data-cy="name" variant="h1">{{product.name}}</raf-text>

            <div class="mt-4 mb-1">
              <raf-text data-cy="description" variant="body-medium">
                <div class="product-detail-short-description"
                     [innerHTML]="product.description || t('PRODUCT_DETAIL.DESCRIPTION_EMPTY')"></div>
              </raf-text>
            </div>

            <a data-cy="read-more" class="mat-button-extra-small edge-left" mat-button routerLink="."
               fragment="description"
               (click)="scrollTo('description')">{{t('PRODUCT_DETAIL.READ_MORE')}}</a>

            <mat-divider class="mt-4 mb-4"></mat-divider>

            <div data-cy="stock" class="mb-4 stack stack-horizontal stack-16 stack-center stack-space-between">
              <raf-stock [stock]="product.stock" [productId]="product.code"></raf-stock>
              <raf-price *ngIf="tablet$ | async" [productPrices]="product.prices"
                         [unit]="product.baseUnit?.symbol" [showTooltip]="true"></raf-price>
            </div>

            <div class="stack stack-horizontal stack-16 stack-center">
              <raf-price data-cy="price" *ngIf="(tablet$ | async) === false" [productPrices]="product.prices"
                         [unit]="product.baseUnit?.symbol" [showTooltip]="true"></raf-price>
              <div class="stack stack-horizontal stack-16 stack-center pt-4" [class.sticky-to-end]="tablet$ | async">
                <raf-quantity data-cy="quantity" [moq]="product.moq" [unit]="product.sellUnit"
                              (valueChange)="onQuantityChange($event)"
                              [debounce]="0"></raf-quantity>
                <button data-cy="add-to-cart-btn" class="mat-button-small" type="button" mat-flat-button color="primary"
                        (click)="onAddToCart()">
                  <raf-icon class="start-icon" icon="cart"></raf-icon>
                  {{t('PRODUCT.ADD_TO_CART')}}</button>
              </div>
            </div>

            <div class="price-info-block mt-4">
              <div *ngIf="product?.prices?.percentageDiscount" class="price-info" data-cy="percentage-discount-info">
                <raf-icon class="price-info-icon" size="16px" icon="percent"></raf-icon>
                <span class="price-info-value">
                  {{ t("GLOBAL.PRICE_INFO.DISCOUNT", {amount: product?.prices?.percentageDiscount}) }}
                </span>
              </div>

              <div *ngIf="product?.prices?.minPriceWithVat?.value" class="price-info" data-cy="min-price-info">
                <raf-icon class="price-info-icon" size="16px" icon="monitoring"></raf-icon>
                <span class="price-info-value">
                  {{ t("GLOBAL.PRICE_INFO.MIN_PRICE_WITH_VAT", {price: product?.prices?.minPriceWithVat | price}) }}
              </span>
              </div>
            </div>

            <mat-divider class="mt-2 mb-4"></mat-divider>

            <div class="stack stack-vertical">
              <div class="stack stack-horizontal">
                <raf-compare-button edge="left" class="mb-3"
                                    [product]="product"></raf-compare-button>
              </div>

              <raf-product-attributes data-cy="product-attr" [product]="product"></raf-product-attributes>
            </div>

          </div>
        </div>
      </raf-section>


      <!-- FRAGMENT NAVIGATION -->

      <div>

        <raf-tab-container data-cy="sticky-section" [sticky]="true" [tabletLayout]="tablet$ | async">
          <a mat-button routerLink="." fragment="description"
             (click)="scrollTo('description')">
            {{t('PRODUCT_DETAIL.DESCRIPTION')}}
          </a>
          <a mat-button routerLink="." fragment="technical-attributes"
             (click)="scrollTo('technical-attributes')" *ngIf="product.attributes?.length">
            {{t('PRODUCT_DETAIL.TECHNICAL_ATTRIBUTES')}}
          </a>
          <a mat-button routerLink="." fragment="attachments"
             (click)="scrollTo('attachments')"
             *ngIf="product.documents?.length">
            {{t('PRODUCT_DETAIL.ATTACHMENTS')}}
          </a>
        </raf-tab-container>


        <raf-section variant="light" gutterBottom="none">
          <div class="product-detail-additional-info">
            <div class="two-side-layout break-lg mt-5">
              <div class="primary-side">
                <!-- DESCRIPTION -->
                <raf-anchor-offset anchorId="description">
                  <raf-text data-cy="full-description-heading" variant="h2" color="primary-color"
                            [gutterBottom]="true">{{t('PRODUCT_DETAIL.DESCRIPTION')}}</raf-text>
                  <div data-cy="full-description" class="nav-tab-offset mb-5"
                       [innerHTML]="product.description || t('PRODUCT_DETAIL.DESCRIPTION_EMPTY')"></div>
                </raf-anchor-offset>
              </div>

              <div class="secondary-side">
                <!-- ATTRIBUTES -->
                <raf-anchor-offset anchorId="technical-attributes" class="mb-5" *ngIf="product.attributes?.length">
                  <raf-product-technical-attributes class="nav-tab-offset"
                                                    [attributes]="product.attributes"></raf-product-technical-attributes>
                </raf-anchor-offset>

                <!-- ATTACHMENTS -->
                <raf-anchor-offset anchorId="attachments" *ngIf="product.documents?.length">
                  <raf-text data-cy="document-dwl-txt" variant="h3" color="primary-color"
                            [gutterBottom]="true">{{t('PRODUCT_DETAIL.ATTACHMENTS')}}</raf-text>
                  <div class="stack stack-vertical">
                    <raf-file-download data-cy="download-section" *ngFor="let doc of product.documents" [file]="doc"
                                       size="medium"></raf-file-download>
                    <!--                    <raf-file-download [file]="{name: 'jsem soubor yo', size: 10, downloadUrl: 'http://google.com', mimeType: 'pdf'}" size="medium"></raf-file-download>-->
                  </div>
                </raf-anchor-offset>
              </div>
            </div>
          </div>
        </raf-section>
      </div>
    </ng-container>

    <ng-container *ngIf="layout$ | async as layout">

      <raf-section gutterTop="normal">
        <raf-promo-block data-cy="promo-block" label="PROMO_BLOCK.LABEL"
                         [content]="layout.shoppingTips"></raf-promo-block>
      </raf-section>

      <raf-section>
        <raf-partners data-cy="partners" [data]="layout.manufacturerList"></raf-partners>
      </raf-section>
    </ng-container>
  </ng-container>

  <raf-error *ngIf="fullPageError$ | async as err" [variant]="err" [fullPage]="true"></raf-error>

</ng-container>




